document.querySelectorAll('.MenuModal').forEach((menuEl) => {
    const divs = menuEl.querySelectorAll('*[data-hover]')
    const listToggle = menuEl.querySelectorAll('*[data-toggle]');
    const allEl = menuEl.parentElement.children[0];

    listToggle.forEach((toggleEl, i) => {
        toggleEl.addEventListener('mouseenter', () => {
            setActive(toggleEl.dataset.toggle);
        });
    });

    allEl.addEventListener('mouseenter', () => {
        setActive('all');
    })

    function setActive(val) {
        listToggle.forEach((toggleEl, i) => {
            toggleEl.classList.toggle('active', toggleEl.dataset.toggle === val);
        })
        divs.forEach((el) => {
            const divVal = el.dataset.hover;
            el.classList.toggle('hide', divVal !== val);
        });
    }
})
